import _t from 'i18n!nls/career-plans';

export const SKILL_LEVEL_PRETTY_NAME = {
  ENTRY_LEVEL: 'Entry level',
  MID_LEVEL: 'Mid level',
  SENIOR_LEVEL: 'Senior level',
};

export const DATA_SCIENTIST_SENIOR = {
  DATA_SCIENTIST: 'Data Scientist',
  SENIOR_LEVEL: 'Senior Level',
};

export const DOMAIN_NAMES_TO_CAREER_NAME: Record<string, string[]> = {
  Business: [
    'agile-project-manager-it',
    'digital-marketing-specialist',
    'digital-marketing-manager',
    'project-coordinator',
    'project-manager',
    'social-media-coordinator',
  ],
  'Data Science': [
    'data-scientist',
    'data-analyst',
    'bi-analyst',
    'bi-developer',
    'data-engineer',
    'project-coordinator-business',
    'project-manager-business',
    'business-analyst',
  ],
  'Arts and Humanities': ['graphic-designer', 'ui/ux-designer'],
  'Computer Science': [
    'computer-user-support-specialist',
    'network-administrator',
    'network-engineer',
    'product-designer',
    'front-end-web-developer',
    'back-end-web-developer',
    'full-stack-developer',
    'front-end-web-developer-python',
    'back-end-web-developer-python',
    'full-stack-developer-python',
  ],
};

// clp domain/browse ab test would run around 1 month. not much change with skills, so hardcode here.
export const CAREER_KEY_SKILLS: Record<string, string> = {
  get 'data-scientist'() {
    return _t('R, Python, Statistics, Data Analysis, Data Visualization, Machine Learning');
  },
  get 'data-analyst'() {
    return _t('Mysql, Math, Statistics');
  },
  get 'bi-analyst'() {
    return _t('SQL, Business intelligence, Data analysis, Tableau');
  },
  get 'bi-developer'() {
    return _t('Python, Software development, SQL, Javascript');
  },
  get 'data-engineer'() {
    return _t('Python, Big Data, ETL');
  },
  get 'social-media-coordinator'() {
    return _t('SEO, Marketing, Social Media, Digital Marketing, Brand');
  },
  get 'digital-marketing-specialist'() {
    return _t('Marketing Analytics, Market Research, Project Management, Excel, SQL (Basic)');
  },
  get 'digital-marketing-manager'() {
    return _t('Marketing leadership, Marketing strategy, Digital marketing');
  },
  get 'project-coordinator'() {
    return _t('Project management, Excel, Scheduling');
  },
  get 'project-manager'() {
    return _t('Project management, Planning, Scheduling, Change management, Software development');
  },
  get 'agile-project-manager-it'() {
    return _t('Project planning and development, Agile development, JIRA, Software development');
  },
  get 'computer-user-support-specialist'() {
    return _t('Information security, Information technology management, Network protocols');
  },
  get 'network-administrator'() {
    return _t('Network configuration, Cloud networking fundamentals, TCP/IP, Virtual private networks');
  },
  get 'network-engineer'() {
    return _t('Advanced network security, Network analysis, Network design, Network optimization');
  },
  get 'graphic-designer'() {
    return _t('Graphic design, Visual design, Typesetting, Creativity, Adobe Illustrator');
  },
  get 'ui/ux-designer'() {
    return _t('User interface design , Design, Adobe Photoshop');
  },
  get 'product-designer'() {
    return _t('User research, UI/UX, Website design, Usability testing, Creativity, Adobe Photoshop, Wireframes');
  },
  get 'project-coordinator-business'() {
    return _t('Project management, Excel, Scheduling');
  },
  get 'project-manager-business'() {
    return _t('Project management, Planning, Scheduling, Change management, Software development');
  },
  get 'business-analyst'() {
    return _t('Data Analysis, Business Process, SQL, Six Sigma');
  },
  get 'front-end-web-developer'() {
    return _t('CSS, HTML, SQL, Java, javascript');
  },
  get 'back-end-web-developer'() {
    return _t('Java, SQL');
  },
  get 'full-stack-developer'() {
    return _t('JavaScript, React, MongoDB');
  },
  get 'front-end-web-developer-python'() {
    return _t('Web development');
  },
  get 'back-end-web-developer-python'() {
    return _t('Django');
  },
  get 'full-stack-developer-python'() {
    return _t('Python, Django, JavaScript');
  },
};

export const CAREER_NAME_TO_SLUG: Record<string, string> = {
  'Data Analyst': 'data-analyst',
  'Data Scientist': 'data-scientist',
  'BI Analyst': 'bi-analyst',
  'BI Developer': 'bi-developer',
  'Data Engineer': 'data-engineer',
  'Computer User Support Specialist': 'computer-user-support-specialist',
  'Network Administrator': 'network-administrator',
  'Network Engineer': 'network-engineer',
  'Product Designer': 'product-designer',
  'Agile Project Manager (IT)': 'agile-project-manager-it',
  'Digital Marketing Specialist': 'digital-marketing-specialist',
  'Digital Marketing Manager': 'digital-marketing-manager',
  'Project Coordinator': 'project-coordinator',
  'Project Manager': 'project-manager',
  'Social Media Coordinator': 'social-media-coordinator',
  'Graphic Designer': 'graphic-designer',
  'UI/UX Designer': 'ui/ux-designer',
  'Front End Web Developer': 'front-end-web-developer',
  'Back End Web Developer': 'back-end-web-developer',
  'Full Stack Developer': 'full-stack-developer',
  'Business Analyst': 'business-analyst',
  'Front End Web Developer (python)': 'front-end-web-developer-python',
  'Back End Web Developer (python)': 'back-end-web-developer-python',
  'Full Stack Developer (python)': 'full-stack-developer-python',
};

export const CAREER_SLUG_TO_NAME: Record<string, string> = {
  get 'data-analyst'() {
    return _t('Data Analyst');
  },
  get 'data-scientist'() {
    return _t('Data Scientist');
  },
  get 'bi-analyst'() {
    return _t('BI Analyst');
  },
  get 'bi-developer'() {
    return _t('BI Developer');
  },
  get 'data-engineer'() {
    return _t('Data Engineer');
  },
  get 'computer-user-support-specialist'() {
    return _t('Computer User Support Specialist');
  },
  get 'network-administrator'() {
    return _t('Network Administrator');
  },
  get 'network-engineer'() {
    return _t('Network Engineer');
  },
  get 'product-designer'() {
    return _t('Product Designer');
  },
  get 'agile-project-manager-it'() {
    return _t('Agile Project Manager (IT)');
  },
  get 'digital-marketing-specialist'() {
    return _t('Digital Marketing Specialist');
  },
  get 'digital-marketing-manager'() {
    return _t('Digital Marketing Manager');
  },
  get 'project-coordinator'() {
    return _t('Project Coordinator');
  },
  get 'project-manager'() {
    return _t('Project Manager');
  },
  get 'social-media-coordinator'() {
    return _t('Social Media Coordinator');
  },
  get 'graphic-designer'() {
    return _t('Graphic Designer');
  },
  get 'ui/ux-designer'() {
    return _t('UI/UX Designer');
  },
  get 'project-coordinator-business'() {
    return _t('Project Coordinator');
  },
  get 'project-manager-business'() {
    return _t('Project Manager');
  },
  get 'business-analyst'() {
    return _t('Business Analyst');
  },
  get 'front-end-web-developer'() {
    return _t('Front End Web Developer');
  },
  get 'back-end-web-developer'() {
    return _t('Back End Web Developer');
  },
  get 'full-stack-developer'() {
    return _t('Full Stack Developer');
  },
  get 'front-end-web-developer-python'() {
    return _t('Front End Web Developer (python)');
  },
  get 'back-end-web-developer-python'() {
    return _t('Back End Web Developer (python)');
  },
  get 'full-stack-developer-python'() {
    return _t('Full Stack Developer (python)');
  },
};

export const DATA_SCIENCE_INDEX_TYPE = 'data_science';
export const COMPUTER_SCIENCE_INDEX_TYPE = 'computer_science';
export const BUSINESS_INDEX_TYPE = 'business';
export const ARTS_INDEX_TYPE = 'arts_and_humanities';
export const BROWSE_CAREER_ORDERED_INDICES = [
  DATA_SCIENCE_INDEX_TYPE,
  COMPUTER_SCIENCE_INDEX_TYPE,
  BUSINESS_INDEX_TYPE,
  ARTS_INDEX_TYPE,
];

export const getIndexTypeToBrowseTabs = (indexType: string) => {
  switch (indexType) {
    case DATA_SCIENCE_INDEX_TYPE:
      return _t('Data Science');
    case COMPUTER_SCIENCE_INDEX_TYPE:
      return _t('Computer Science');
    case BUSINESS_INDEX_TYPE:
      return _t('Business');
    case ARTS_INDEX_TYPE:
      return _t('Arts and Humanities');
    default:
      return _t('Data Science');
  }
};

export const getCareerPlansData = () => [
  {
    name: 'Project Management',
    slug: 'project-management',
    skillsLearned: ['Project management', 'Planning', 'Scheduling', 'Change management', 'Software development'],
    partnerList: ['University of California, Irvine', 'Macquarie University', 'University of Virginia'],
    careerPath: [
      {
        name: 'Project Coordinator',
        level: 'Entry level',
      },
      {
        name: 'Project Manager',
        level: 'Mid level',
      },
      {
        name: 'Agile Project Manager (IT)',
        level: 'Senior level',
      },
    ],
  },
  {
    name: 'Network Engineering',
    slug: 'network-engineering',
    skillsLearned: [
      'Information security',
      'Information technology management',
      'Network protocols and troubleshooting',
      'Customer support',
      'Hardware and software installation',
      'Network configuration',
      'Cloud networking fundamentals',
      'TCP/IP',
      'Virtual private networks',
      'Cisco networks',
      'Network troubleshooting',
    ],
    partnerList: [
      'University of California, Davis',
      'University of Colorado, Boulder',
      'Yandex',
      'Cloudera',
      'University of California, Davis',
      'PwC',
      'University of Michigan',
      'Cloudera',
      'University of Minnesota',
      'The Hong Kong University of Science and Technology',
      'PwC',
      'Stanford',
      'University of California, San Diego',
      'Google Cloud',
      'EPFL',
      'University of California, Davis',
    ],
    careerPath: [
      {
        name: 'Computer User Support Specialist',
        level: 'Entry level',
      },
      {
        name: 'Network Administrator',
        level: 'Mid level',
      },
      {
        name: 'Network Engineer',
        level: 'Senior level',
      },
    ],
  },
  {
    name: 'Digital Marketing',
    slug: 'digital-marketing',
    skillsLearned: [
      'SEO',
      'Marketing',
      'Social Media',
      'Digital Marketing',
      'Brand',
      'Marketing Analytics',
      'Market Research',
      'Project Management',
      'Excel',
      'SQL (Basic)',
      'Marketing leadership',
      'Marketing strategy',
      'Digital marketing',
    ],
    partnerList: [
      'University of California, Davis',
      'Northwestern',
      'University of Pennslyvania',
      'University of California, Davis',
      'Northwestern',
      'IE Business School',
      'University of Pennslyvania',
      'University of Colorado Boulder',
      'IE Business School',
      'Imperial College London',
    ],
    careerPath: [
      {
        name: 'Social Media Coordinator',
        level: 'Entry Level',
      },
      {
        name: 'Digital Marketing Specialist',
        level: 'Mid Level',
      },
      {
        name: 'Digital Marketing Manager',
        level: 'Mid Level',
      },
    ],
  },
  {
    name: 'Design',
    slug: 'design',
    skillsLearned: [
      'Graphic design',
      'Visual design',
      'Typesetting',
      'Creativity',
      'Adobe Illustrator',
      'User interface design ',
      'Design',
      'Adobe Photoshop',
      'User research',
      'UI/UX',
      'Website design',
      'Usability testing',
      'Creativity',
      'Adobe Photoshop',
      'Wireframes',
      'Prototypes',
    ],
    partnerList: [
      'University of California, Davis',
      'Northwestern',
      'University of Pennslyvania',
      'University of California, Davis',
      'Northwestern',
      'IE Business School',
      'University of Pennslyvania',
      'University of Colorado Boulder',
      'IE Business School',
      'Imperial College London',
    ],
    careerPath: [
      {
        name: 'Graphic Designer',
        level: 'Entry level',
      },
      {
        name: 'UI/UX Designer',
        level: 'Mid level',
      },
      {
        name: 'Product Designer',
        level: 'Senior level',
      },
    ],
  },
  {
    name: 'Data Science',
    slug: 'data-science',
    skillsLearned: [
      'Mysql',
      'Math',
      'Statistics',
      'R',
      'Python',
      'Statistics',
      'Data Analysis',
      'Data Visualization',
      'Machine Learning',
      'TensorFlow',
      'Machine Learning',
      'Deep Learning',
    ],
    partnerList: [
      'University of California, Davis',
      'Northwestern',
      'University of Pennslyvania',
      'University of California, Davis',
      'Northwestern',
      'IE Business School',
      'University of Pennslyvania',
      'University of Colorado Boulder',
      'IE Business School',
      'Imperial College London',
    ],
    careerPath: [
      {
        name: 'Data Analyst',
        level: 'Entry level',
      },
      {
        name: 'Data Scientist',
        level: 'Entry level',
      },
      {
        name: 'Data Scientist',
        level: 'Senior Level',
      },
    ],
  },
  {
    name: 'Data Engineering',
    slug: 'data-engineering',
    skillsLearned: [
      'SQL',
      'Business intelligence',
      'Data analysis',
      'Tableau',
      'Python',
      'Software development',
      'SQL',
      'Javascript',
      'Python',
      'Big Data',
      'ETL',
    ],
    partnerList: [
      'Cal Arts',
      'Cal Arts',
      'Institute for the Future',
      'Michigan State University',
      'Georgia Tech',
      'University of Colorado Boulder',
      'Cal Arts',
      'University of Michigan',
      'University of California, San Diego',
      'University of Minnesota',
      'University of Virginia',
      'University of Michigan',
      'Imperial College London',
      'The University of Sydney',
      'Northwestern',
      'McMaster University',
    ],
    careerPath: [
      {
        name: 'BI Analyst',
        level: 'Entry level',
      },
      {
        name: 'BI Developer',
        level: 'Mid Level',
      },
      {
        name: 'Data Engineer',
        level: 'Senior level',
      },
    ],
  },
];
